import { SET_PLANS, } from "./types";

const initialState = {
	plans: []
};

export default function (state = initialState, action) {

	switch (action.type) {
		case SET_PLANS:
			return {
				...state,
				plans: action.details
			}

		default:
			return state;
	}
}